import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from "../common/service/mpvAppConfigService";
import { HttpApiService } from "../common/service/mpvHttpApiService";
import { SigedCommonService } from "../siged-common.service";
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})

export class FavoriteService {

  constructor(
    public httpApiService: HttpApiService,
    public mpvCommonService: SigedCommonService,
  ) {

  }

  baseUrl = this.mpvCommonService.APPLICATION_API_HOST + "/";

  favoriteList(params, headers?): Promise<any> {
    return this.httpApiService.get(this.baseUrl, 'expedienteFav/listarFavorito', { params })
  }

  insertFavorite(body: { [key: string]: string | number }, opts?) {
    return this.httpApiService.post(this.baseUrl, 'expedienteFav/registro', body, { ...opts })
  }

  updateFavorite(body: { [key: string]: string | number }, opts?) {
    return this.httpApiService.post(this.baseUrl, 'expedienteFav/actualizar', body, { ...opts })
  }

}
